
import { RestaurantSearch } from "@/components/RestaurantSearch";
import { useIsMobile } from "@/hooks/use-mobile";

export const RestaurantHeader = ({ onSearch }: { onSearch: (query: string) => void }) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="relative bg-gradient-to-br from-primary to-primary/90 text-white">
      <div className={`container mx-auto px-4 ${isMobile ? 'py-4' : 'py-6'} transition-all duration-300`}>
        <div className="max-w-3xl mx-auto text-center space-y-3">
          <h1 className={`font-bold ${isMobile ? 'text-xl' : 'text-2xl'} leading-tight`}>
            Find Private Event Spaces in NYC
          </h1>
          <p className={`text-white/80 ${isMobile ? 'text-sm' : 'text-base'} max-w-xl mx-auto`}>
            Discover the perfect venue for your next event
          </p>
        </div>
      </div>
      <div className="absolute inset-0 bg-[url('/pattern.png')] opacity-5 pointer-events-none" />
    </div>
  );
};
